








































































import Vue from 'vue'
import Component from 'vue-class-component'
import {IconDefinition, faArrowLeft, faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import { ColorTheme, CategoryModel, ChangeCategoryStatusModel, StatusType } from '@/services/types'
import {StoreActionTypes} from '@/store/types'
import FormInput from '@/components/lib/input/FormInput.vue'
import ActionButton from '@/components/lib/button/ActionButton.vue'
import ModalComponent from '@/components/modal/ModalComponent.vue'
import ConfirmationComponent from '@/components/modal/ConfirmationComponent.vue'

@Component({
	components: {
		FormInput,
		ActionButton,
		ModalComponent,
		ConfirmationComponent
	},
	watch: {
		'$store.getters.getCategoriesSelectedCategory': 'setEditedCategoryName'
	}
})
export default class CategoryDetailsHeader extends Vue {
	private componentClass = "CategoryDetailsHeader"
	private back: IconDefinition = faArrowLeft
	private edit: IconDefinition = faPencilAlt
	private showChangeCategoryNameForm = false
	private editedCategoryName = ''
	private changeStatusCategoryConfirmationShow = false
	private deleteCategoryConfirmationShow = false

	mounted() {
		this.setEditedCategoryName()
	}

	getCategoryStatus(): StatusType {
		return (this.$store.getters.getCategoriesSelectedCategory as CategoryModel) ? (this.$store.getters.getCategoriesSelectedCategory as CategoryModel).status : null
	}

	get categoryName() {
		return (this.$store.getters.getCategoriesSelectedCategory as CategoryModel) ? (this.$store.getters.getCategoriesSelectedCategory as CategoryModel).name : ''
	}

	get statusDropdownTitle() {
		return this.getCategoryStatus() == 'ACTIVE' ? 'Активна' : 'Не активна'
	}

	get statusDropdownItemTitle() {
		return this.getCategoryStatus() == 'ACTIVE' ? 'Деактивировать' : 'Активировать'
	}

	get statusDropdownItemVariant(): ColorTheme {
		return this.getCategoryStatus()   == 'ACTIVE' ? 'success' : 'warning'
	}

	get modalChangeCategoryNameFormDisabled() {
		return this.disabled || this.editedCategoryName.length < 3
	}

	get disabled (){
		return this.$store.getters.isCategoriesDataLoading
	}

	handleEditCategoryNameBtnClick() {
		this.showChangeCategoryNameForm = !this.showChangeCategoryNameForm
	}
	
	categoryNameChange(text: string) {
		this.editedCategoryName = text
	} 

	async handleModalChangeCategoryNameFormOkBtnClick() {
		await this.editCategoryName()
		this.handleEditCategoryNameBtnClick()
	}

	async editCategoryName() {
		await this.$store.dispatch(StoreActionTypes.SET_CATEGORIES_CATEGORY_CHANGE_NAME, this.editedCategoryName)
	}

	handleBackIconClick() {
		this.$store.dispatch(StoreActionTypes.SET_CATEGORIES_SELECTED_CATEGORY_CLEAR)
		this.$router.push('/categories')
	}

	setEditedCategoryName() {
		this.editedCategoryName = (this.$store.getters.getCategoriesSelectedCategory as CategoryModel) ? (this.$store.getters.getCategoriesSelectedCategory as CategoryModel).name : ''
	}

	handleChangeStatusItemClick() {
		this.changeStatusCategoryConfirmationShow = true
	}

	async changeCategoryStatus() {
        const model: ChangeCategoryStatusModel = {
			id: (this.$store.getters.getCategoriesSelectedCategory as CategoryModel).id,
			status: (this.$store.getters.getCategoriesSelectedCategory as CategoryModel).status 
		}
		await this.$store.dispatch(StoreActionTypes.SET_CATEGORIES_CATEGORY_CHANGE_STATUS, model)

        this.changeCategoryStatusCancel()
    }

	changeCategoryStatusCancel() {
        this.changeStatusCategoryConfirmationShow = false
    }

	get setChangeStatusConfirmationOkBtnVariant() {
        return this.getOkBtnVariant(
            this.getCategoryStatus()
        )
    }
    
    getOkBtnVariant(status: StatusType): ColorTheme {
        return status == 'ACTIVE' ? 'danger' : 'success'
    }

	handleDeleteCategoryBtnClick() {
		this.deleteCategoryConfirmationShow = true
	}

	deleteCategoryCancel() {
        this.deleteCategoryConfirmationShow = false
    }

	async deleteCategory() {
        await this.$store.dispatch(StoreActionTypes.SET_CATEGORIES_CATEGORY_DELETE, {
            ids: [(this.$store.getters.getCategoriesSelectedCategory as CategoryModel) ? (this.$store.getters.getCategoriesSelectedCategory as CategoryModel).id : null]
        })

        this.deleteCategoryCancel()
		this.handleBackIconClick()
    }
}
